import { z } from 'zod';

import { AddressSchema } from '@/components/shared/components/NewContextForms/components/AutocompleteAddressHeadless/schemas/AddressSchema';
import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';

export const MerchantLegalAddressSchema = (t: GetTextIdTranslationType) =>
  z
    .object({
      legalAddress: AddressSchema(t),
    })
    .strict();

export type MerchantLegalAddressType = z.infer<ReturnType<typeof MerchantLegalAddressSchema>>;
